import axios from 'axios';
import Bugsnag from '@bugsnag/js';
import _ from 'lodash';
import {
  IS_LOADING,
  PATIENT_GET_HEALTH_RECORD,
  PATIENT_GET_DOCUMENT,
  PATIENT_CLEAR
} from './types';

export const patientGetHealthRecord = patCode => async dispatch => {
  let url = `patientHealthRecord?patCode=${patCode}&limit=500`;

  const columns = ['type', 'value', 'createdAt'];
  if (columns.length > 0) {
    url += `&attrType=custom&${columns.map((column, key) => `attributes[${key}]=${column}`).join('&')}`;
  }

  dispatch({ type: PATIENT_CLEAR });
  dispatch({ type: IS_LOADING, status: true, names: { PATIENT_GET_HEALTH_RECORD: true } });
  await axios.get(url).then(response => {
    const resData = response.data;
    const data = ((resData && resData.data) || []);
    dispatch({ type: PATIENT_GET_HEALTH_RECORD, playload: { dataHealthRecords: data, status: 'success' } });
    dispatch({ type: IS_LOADING, status: false, names: { PATIENT_GET_HEALTH_RECORD: false } });
  }).catch(err => {
    let error = err;
    dispatch({ type: PATIENT_GET_HEALTH_RECORD, playload: { dataHealthRecords: [], status: 'success' } });
    dispatch({ type: IS_LOADING, status: false, names: { PATIENT_GET_HEALTH_RECORD: false } });
    if ((_.has(error, 'response.status') && error.response.status === 502) || _.isUndefined(error.response)) {
      if (_.isUndefined(error.response)) { error = Error(`502 API at ${url}`); }
      Bugsnag.notify(error);
    }
  });
};

export const patientGetDocument = patCode => async dispatch => {
  let url = `patientFiles?patCode=${patCode}&limit=100`;
  const columns = [];

  if (columns.length > 0) {
    url += `&attrType=custom&${columns.map((column, key) => `attributes[${key}]=${column}`).join('&')}`;
  }

  dispatch({ type: PATIENT_CLEAR });
  dispatch({ type: IS_LOADING, status: true, names: { PATIENT_GET_DOCUMENT: true } });
  await axios.get(url).then(response => {
    const resData = response.data;
    const data = ((resData && resData.data) || []);
    dispatch({ type: PATIENT_GET_DOCUMENT, playload: { dataDocumentFiles: data, status: 'success' } });
    dispatch({ type: IS_LOADING, status: false, names: { PATIENT_GET_DOCUMENT: false } });
  }).catch(err => {
    let error = err;
    dispatch({ type: PATIENT_GET_DOCUMENT, playload: { dataDocumentFiles: [], status: 'success' } });
    dispatch({ type: IS_LOADING, status: false, names: { PATIENT_GET_DOCUMENT: false } });
    if ((_.has(error, 'response.status') && error.response.status === 502) || _.isUndefined(error.response)) {
      if (_.isUndefined(error.response)) { error = Error(`502 API at ${url}`); }
      Bugsnag.notify(error);
    }
  });
};

export const referralPatientClear = () => dispatch => {
  dispatch({ type: PATIENT_CLEAR });
};
